import React from 'react';
import './Banner.scss';

const Banner = (props) => {
    return (
        <div className="Banner">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col">
                        <h1 className="banner-title">{props.bannerTitle}</h1>
                    </div>
                    <div className="col-md-3 my-2">
                        <form className="d-flex">
                            <input className="form-control me-2 bg-dark text-light rounded-pill border-danger" type="search" placeholder="Search Game" aria-label="Search" />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;
